export default {
    nav: {
        home: 'Inicio',
        products: 'Productos',
        solutions: 'Soluciones',
        support: 'Soporte',
        aboutUs: 'Sobre nosotros',
        contact: 'Contáctenos',
        software: 'Software'
    },
    hero: {
        title: 'Kooyii Smart',
        desc1: 'Podemos proporcionar aplicaciones de hogar inteligente personalizadas.',
        desc2: 'Si desea una aplicación con el estilo de su marca, servidores privados...',
        desc3: 'Entonces somos su mejor opción.'
    },
    main1: {
        title: 'Página de inicio personalizada',
        subtitle: 'La aplicación Kooyii le permite elegir accesos directos según sus hábitos, facilitando el control de los dispositivos.',
        desc1: 'La nube sincroniza automáticamente la fecha y hora locales.',
        desc2: 'Agregue cámaras al inicio para ver transmisiones fácilmente. Haga clic para usar el PTZ y ajustar la dirección de la cámara.',
        desc3: 'Agregue cerraduras al inicio para desbloquearlas de forma remota y cómoda.',
        desc4: 'La nube sincroniza automáticamente el clima y la temperatura locales.',
        desc5: 'Armado/desarmado en lote para hosts de alarma y puertas de enlace.',
        desc6: 'Agregue interruptores al inicio para encender/apagar luces rápidamente.',
        desc7: 'Agregue cortinas al inicio para controlar rápidamente su apertura/cierre/pausa.'
    },
    main2: {
        title: 'Gestión de dispositivos',
        subtitle: 'La aplicación Kooyii muestra los dispositivos por zonas, permitiéndole encontrarlos y controlarlos más rápido.',
        desc1: 'Seleccione una zona para mostrar los dispositivos de esa área.',
        desc2: 'Haga clic para controlar cortinas de forma remota y configurar su rotación.',
        desc3: 'Haga clic para ajustar remotamente el encendido, brillo y temperatura de color de las luces.',
        desc4: 'Haga clic para agregar/controlar televisores, aires acondicionados, etc.',
        desc5: 'Haga clic para eliminar dispositivos o asignarles una zona.',
        desc6: 'Haga clic para encender/apagar luces remotamente, configurar temporizadores, etc.',
        desc7: 'Haga clic para armar/desarmar remotamente, agregar subdispositivos, configurar fondos, etc.',
        desc8: 'Haga clic para operar puertas de enlace VRF para aire acondicionado central.'
    },
    main3: {
        title: 'Escenas inteligentes y automatización',
        subtitle: 'Configure escenas y automatizaciones para lograr una vinculación inteligente en toda la casa.',
        desc1: 'Haga clic para cambiar entre escenas y automatización.',
        desc2: 'Haga clic para ingresar a la página de edición y modificar o eliminar comandos.',
        desc3: 'Haga clic para agregar una escena, seleccione el dispositivo y la acción; entrará en vigor de inmediato.',
        desc4: 'Haga clic para ejecutar escenas preestablecidas con un solo toque.'
    },
    about: {
        title: 'Sobre nosotros',
        desc1: 'Kooyii es una aplicación móvil integral desarrollada de forma independiente por Shenzhen Golden Security Technology Co., Ltd., que integra el hogar inteligente y las alarmas de seguridad. A través de la aplicación, los usuarios pueden agregar y controlar dispositivos, configurar escenas de automatización y recibir alarmas en cualquier momento y lugar.',
        desc2: 'La aplicación admite el control de dispositivos inteligentes a través de múltiples protocolos, cubriendo escenarios como hogares inteligentes, alarmas de seguridad, hoteles inteligentes y automatización de edificios.',
        desc3: 'Como empresa de alta tecnología que integra I+D, producción y ventas, ofrecemos a los clientes servicios como desarrollo de hardware, personalización de software e implementación privada para satisfacer diversas necesidades.'
    },
    protocol: {
        title: 'Protocolos de comunicación',
        cards: {
            zigbee: 'Zigbee 3.0 es un estándar de comunicación inalámbrica unificado introducido por la Connectivity Standards Alliance (CSA), que permite una interoperabilidad fluida entre marcas y redes de malla de bajo consumo al integrar protocolos de aplicaciones fragmentados.',
            wifi: 'Wi-Fi es una tecnología de red inalámbrica reconocida mundialmente que transmite datos a través de ondas de radio, permitiendo que los dispositivos se conecten a las redes sin cables físicos.',
            rf433: '433MHz es una banda de radio de baja frecuencia comúnmente utilizada para dispositivos de corto alcance y bajo consumo, como sistemas de alarma de seguridad e interruptores inteligentes.',
            modbus: 'Modbus es un protocolo de comunicación en serie ampliamente utilizado en la automatización industrial, que admite la comunicación maestro-esclavo y el intercambio de datos.',
            knx: 'KNX es una tecnología de bus estándar europea ampliamente utilizada en sistemas de automatización para edificios inteligentes.',
            bluetooth: 'Bluetooth es una tecnología inalámbrica para la comunicación entre dispositivos, ampliamente utilizada en hoteles inteligentes, hogares inteligentes y otros campos.'
        }
    },
    features: {
        title: 'Qué puedes hacer con esta App',
        remoteControl: {
            title: 'Control Remoto',
            desc: 'Controla dispositivos inteligentes de forma remota.'
        },
        armDisarm: {
            title: 'Armar/Desarmar',
            desc: 'Configura los modos de armado y desarmado para el host de alarma.'
        },
        alarmPush: {
            title: 'Recibir Alarmas',
            desc: 'Recibe notificaciones instantáneas en tu teléfono cuando se active la alarma.'
        },
        scenes: {
            title: 'Escenas Inteligentes',
            desc: 'Configura la ejecución con un solo toque según tus necesidades.'
        },
        automation: {
            title: 'Automatización',
            desc: 'Permite que tus dispositivos ejecuten comandos automáticamente cuando se cumplen ciertas condiciones.'
        },
        familyShare: {
            title: 'Compartir en Familia',
            desc: 'Invita a tu familia a administrar los dispositivos juntos.'
        }
    },
    services: {
        title: 'Escenarios de aplicación',
        features: {
            smartHome: {
                title: 'Hogar Inteligente',
                desc: 'Rompa las limitaciones de los hogares tradicionales para crear un espacio de vida inteligente para todos los escenarios. Compatible con múltiples protocolos como Zigbee y Wi-Fi, permite la interconectividad de dispositivos y el cambio de escena sin interrupciones. Desbloquee un estilo de vida altamente eficiente y conveniente con operaciones minimalistas, brindando la calidez de la tecnología a su experiencia de vida.'
            },
            security: {
                title: 'Seguridad Inteligente',
                desc: 'Un host de alarma emparejado con una plataforma de monitoreo profesional para construir un sistema de seguridad integrado. Como núcleo del sistema, el host se conecta a varios detectores (infrarrojos, humo, botones de emergencia) a través del protocolo de 433MHz, lo que permite alertas en tiempo real de intrusiones, incendios y emergencias.'
            },
            hotel: {
                title: 'Hotel Inteligente',
                desc: 'Centrada en IoT y combinada con una plataforma de gestión de equipos de hotel, esta solución conecta habitaciones inteligentes, operaciones de recepción y servicios de habitación, ofreciendo doble valor tanto a los huéspedes como a la gestión del hotel.'
            },
            building: {
                title: 'Automatización de Edificios',
                desc: 'Basado en RTU y configurado a través de un backend de gestión, admite la integración de dispositivos Modbus para lograr fácilmente un monitoreo centralizado, control inteligente y gestión de energía del equipo del edificio, transformando los edificios tradicionales en inteligentes.'
            }
        }
    },
    software: {
        title: 'Software y Plataformas',
        steps: {
            cms: { title: 'Centro de Recepción de Alarmas', desc: 'Haga clic para visitar' },
            kooyii: { title: 'Kooyii', desc: 'Pase el cursor para escanear y descargar' },
            elderly: { title: 'Cuidado Inteligente de Ancianos', desc: 'Experiencia aún no disponible. Contacte a ventas para más detalles.' },
            hotel: { title: 'Hotel Inteligente', desc: 'Experiencia aún no disponible. Contacte a ventas para más detalles.' },
            building: { title: 'Automatización de Edificios', desc: 'Experiencia aún no disponible. Contacte a ventas para más detalles.' },
            more: { title: 'Más Escenarios', desc: 'Por favor contacte a ventas para asesoramiento profesional.' }
        }
    },
    solutions: {
        services: {
            title: 'Nuestros Servicios',
            features: {
                hardware: {
                    title: 'Personalización de Hardware',
                    desc: 'Servicios exclusivos de diseño y fabricación integrales, desde las placas PCBA centrales hasta la estética del dispositivo completo. Cubre el diseño de circuitos, selección de componentes, diseño de PCB, depuración funcional, moldes de carcasa, materiales y protección estructural.'
                },
                software: {
                    title: 'Personalización de Software',
                    desc: 'Desarrollo de aplicaciones y sistemas web a medida basados en sus necesidades comerciales reales, incluyendo aplicaciones móviles (iOS/Android), páginas web para PC y gestión de backend. Proporcionando una solución digital altamente eficiente adaptada a su modelo operativo.'
                },
                server: {
                    title: 'Implementación Privada',
                    desc: 'Implemente sistemas, plataformas o aplicaciones completamente en sus propios servidores o entornos de intranet designados. Los datos y los servicios se ejecutan de forma completamente independiente, logrando un control autónomo total.'
                }
            }
        },
        whyUs: {
            title: '¿Por qué elegirnos?',
            benefits: {
                oneStop: {
                    title: 'Servicio Todo en Uno',
                    desc: 'Nuestras soluciones cubren tanto el software como el hardware con una alineación integral unificada, eliminando la coordinación entre múltiples partes, acortando los ciclos de desarrollo y reduciendo los costos de comunicación.'
                },
                custom: {
                    title: 'Personalización Profunda',
                    desc: 'Las funciones del software se combinan con precisión con el rendimiento del hardware, evitando problemas de compatibilidad y garantizando un funcionamiento general más fluido con tasas de falla más bajas.'
                },
                expandable: {
                    title: 'Alta Escalabilidad',
                    desc: 'Nuestros servicios reservan interfaces de expansión, lo que facilita a los clientes la actualización y expansión de funcionalidades según sus necesidades futuras.'
                },
                deployment: {
                    title: 'Implementación Flexible',
                    desc: 'Ya sea una implementación privada localizada o una implementación en la nube pública, brindamos soluciones flexibles para satisfacer sus necesidades.'
                }
            }
        },
        cta: {
            title: '¿Listo para mejorar su estilo de vida?',
            desc: 'Hable hoy con nuestros expertos en hogares inteligentes y permítanos diseñar el ecosistema perfecto para usted.',
            button: 'Contactar a Ventas'
        }
    },
    product: {
        nav: {
            panel: 'Paneles de Control',
            hub: 'Hubs Inteligentes',
            switch: 'Interruptores Inteligentes',
            curtain: 'Cortinas Inteligentes',
            sensor: 'Sensores',
            lighting: 'Iluminación Inteligente',
            security: 'Seguridad Inteligente',
            doorlock: 'Cerraduras Inteligentes'
        },
        sub: {
            '4inch': '4 Pulgadas',
            '5inch': '5 Pulgadas',
            '6inch': '6 Pulgadas',
            '7inch': '7 Pulgadas',
            '8inch': '8 Pulgadas',
            '10inch': '10 Pulgadas',
            '1gang': '1 Vía',
            '2gang': '2 Vías',
            '3gang': '3 Vías',
            '4gang': '4 Vías',
            'wireless': 'Inalámbrico',
            'wired': 'Con cable',
            'openclose': 'Motor de Cortina',
            'roller': 'Persiana Enrollable',
            'downlight': 'Focos y Downlights',
            'magnetic': 'Luces de Carril Magnético',
            'strip': 'Tiras de Luz',
            'alarm': 'Host de Alarma',
            'door': 'Sensor de Puerta/Ventana',
            'smoke': 'Detector de Humo',
            'infrared': 'Detector Infrarrojo',
            'radar': 'Radar de Presencia Humana',
            'water': 'Sensor de Fuga de Agua',
            'temp': 'Sensor de Temp. y Humedad',
            'indoorCam': 'Cámara Interior',
            'outdoorCam': 'Cámara Exterior',
            'password': 'Cerradura con Contraseña',
            'fingerprint': 'Cerradura con Huella',
            'face': 'Cerradura Facial'
        },
        common: {
            learnMore: 'Saber más',
            addToCart: 'Añadir al carrito',
            buyNow: 'Comprar ahora',
            emptyProduct: 'Aún no hay productos relacionados. Por favor, manténgase atento...'
        },
        cart: {
            titleList: 'Lista de Solicitudes',
            titleForm: 'Información de Contacto',
            empty: '¡Su lista está vacía, agregue algunos productos!',
            delete: 'Eliminar',
            totalItems: 'Total de {count} productos seleccionados',
            nextStep: 'Siguiente Paso: Rellenar Información',
            submit: 'Enviar Solicitud'
        },
        form: {
            name: '¿Cómo deberíamos llamarle?',
            namePlaceholder: 'Por favor ingrese su nombre',
            address: 'Dirección de la empresa',
            addressPlaceholder: 'Por favor ingrese la dirección de su empresa',
            location: 'Ciudad / País',
            locationPlaceholder: 'Ej., Madrid, España',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Ingrese su WhatsApp para contactarle',
            email: 'Correo electrónico',
            emailPlaceholder: 'Ingrese su correo electrónico',
            remark: 'Comentarios',
            remarkPlaceholder: 'Ingrese cualquier comentario sobre sus necesidades',
            zipCode: 'Código Postal',
            zipCodePlaceholder: 'Ingrese su código postal'
        },
        alert: {
            fillRequired: 'Por favor complete todos los campos obligatorios (*)',
            submitSuccess: '¡Solicitud enviada con éxito! Nuestro equipo de ventas le contactará en breve.',
            confirm: 'Confirmar',
            notice: 'Aviso',
            success: '¡Éxito!'
        }
    },
    contact: {
        hero: {
            title: 'Contáctenos',
            desc: 'Obtenga asesoramiento profesional y las soluciones más adecuadas para usted'
        },
        form: {
            title: 'Envíenos un mensaje',
            subtitle: 'Complete el formulario y nos pondremos en contacto con usted en 24 horas.',
            firstName: 'Nombre',
            firstNamePlaceholder: 'Ej., Juan',
            lastName: 'Apellido',
            lastNamePlaceholder: 'Ej., Pérez',
            email: 'Correo de trabajo',
            emailPlaceholder: "juan{'@'}empresa.com",
            inquiryType: 'Tipo de consulta',
            selectTopic: 'Seleccione un tema...',
            message: 'Mensaje',
            messagePlaceholder: '¿En qué podemos ayudarle?',
            submitBtn: 'Enviar mensaje',
            sending: 'Enviando...',
            successMsg: '¡Gracias! Su mensaje ha sido enviado con éxito.'
        },
        inquiry: {
            general: 'Consulta General',
            sales: 'Ventas y Distribución',
            support: 'Soporte Técnico',
            hardware: 'OEM/ODM'
        },
        location: {
            title: 'Dónde estamos',
            officeName: 'Sede de Shenzhen',
            address: 'Habitación 603, Unidad 1, Edificio 1, Plaza Kailifang, Calle Lianrun, Comunidad Taoyuan, Calle Dalang, Distrito de Longhua, Shenzhen, Guangdong, China',
            phone: '+86 18926403313 Srta. Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}